(function(register){
    if (document.readyState !== 'loading') {
        register();
    } else {
        document.addEventListener('DOMContentLoaded', register, {
            once: true,
            passive: true,
        });
    }
})(function() {
    if (customElements.get('base-slide-content') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
            --slide-content-duration-regular: 500;
            --slide-content-duration-fast: 250;
            --slide-content-duration-superfast: 125;
            --slide-content-duration-slow: 750;
            --slide-content-duration-superslow: 1000;
            --slide-content-duration-: var(--slide-content-duration-regular);
            display: block;
            height: 0;
            overflow: hidden;
        }
        :host([open]:not([duration])) {
            height: auto;
        }
        </style>
        <slot></slot>
        `;
        customElements.define('base-slide-content', class extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
            }

            connectedCallback() {
                if (this.id) {
                    Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`)).forEach(control => {
                        control.addEventListener('click', () => this.slideToggle());
                        if (!(control instanceof HTMLButtonElement)) {
                            control.addEventListener('keydown', event => {
                                if (event.code === 'Space' || event.code === 'Enter') {
                                    event.preventDefault();
                                    this.slideToggle();
                                }
                            })
                        }
                        if (control.hasAttribute('aria-expanded')) {
                            this.addEventListener('base-slide-down.open', () => {
                                control.setAttribute('aria-expanded', 'true');
                            });
                            this.addEventListener('base-slide-down.close', () => {
                                control.setAttribute('aria-expanded', 'false');
                            });
                        }
                    });
                }
                if (this.hasAttribute('open')) {
                    this.style.height = 'auto';
                    this.style.overflow = 'visible';
                } else {
                    this.style.display = 'none';
                }
            }

            get duration() {
                if (this.hasAttribute('duration')) {
                    const duration = this.getAttribute('duration');
                    const styles = getComputedStyle(this);
                    const propValue = styles.getPropertyValue(`--slide-content-duration-${duration}`);
                    if (propValue) {
                        return parseInt(propValue);
                    } else {
                        return parseInt(duration);
                    }
                }
                return 0;
            }

            slideToggle(disableAnimation = false) {
                if (this.hasAttribute('open')) {
                    this.slideUp(disableAnimation);
                } else {
                    this.slideDown(disableAnimation);
                }
            }

            slideDown(disableAnimation) {
                if (this.hasAttribute('open')) {
                    return;
                }
                this.style.display = null;
                this.setAttribute('open', 'open');
                this.dispatchEvent(new CustomEvent('base-slide-down.open', {
                    bubbles: true,
                    cancelable: false
                }));
                let opened = () => {
                    this.style.height = 'auto';
                    this.style.overflow = 'visible';
                    this.dispatchEvent(new CustomEvent('base-slide-down.opened', {
                        bubbles: true,
                        cancelable: false,
                    }));
                };
                const duration = disableAnimation ? 0 : this.duration;
                if (duration) {
                    if (this.animation && this.animation.playState !== "finished") {
                        this.animation.cancel();
                    }
                    this.animation = this.animate([
                        {height: `${this.scrollHeight}px`}
                    ], {
                        duration: duration,
                        iterations: 1,
                        easing: this.getAttribute('easing-in') || 'ease-out',
                    });
                    this.animation.onfinish = opened;
                } else {
                    opened();
                }
            }

            slideUp(disableAnimation) {
                if (!this.hasAttribute('open')) {
                    return;
                }
                this.removeAttribute('open');
                this.dispatchEvent(new CustomEvent('base-slide-down.close', {
                    bubbles: true,
                    cancelable: false
                }));
                let closed = () => {
                    this.style.height = '0px';
                    this.style.display = 'none';
                    this.dispatchEvent(new CustomEvent('base-slide-down.closed', {
                        bubbles: true,
                        cancelable: false
                    }));
                }
                const duration = disableAnimation ? 0 : this.duration;
                this.style.overflow = 'hidden';
                if (duration) {
                    if (this.animation && this.animation.playState !== "finished") {
                        this.animation.cancel();
                    }
                    this.style.height = `${this.scrollHeight}px`;
                    this.animation = this.animate([
                        {height: 0}
                    ], {
                        duration: duration,
                        iterations: 1,
                        easing: this.getAttribute('easing-out') || 'ease-out',
                    });
                    this.animation.onfinish = closed;
                } else {
                    closed();
                }
            }
        });
    }
});
